import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import { type PropsWithChildren, type ReactNode, useState } from "react";

type Props = {
	title: string;
	icon?: ReactNode;
	expandable?: boolean;
	defaultExpanded?: boolean;
};

export const CollapsibleSection = ({
	title,
	icon,
	expandable = false,
	defaultExpanded = false,
	children,
}: PropsWithChildren<Props>) => {
	const theme = useTheme();
	const [isExpanded, setIsExpanded] = useState(defaultExpanded);
	const showChildren = !expandable || isExpanded;

	return (
		<>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				px={1.6}
				py={1}
				onClick={expandable ? () => setIsExpanded(!isExpanded) : undefined}
				sx={expandable ? { cursor: "pointer" } : undefined}
			>
				<Stack direction="row" alignItems="center" gap="8px">
					{icon}
					<Typography
						fontSize={12}
						fontWeight={600}
						color={theme.palette.grey[500]}
						textTransform="uppercase"
						letterSpacing={0.8}
					>
						{title}
					</Typography>
				</Stack>
				{expandable &&
					(isExpanded ? (
						<ChevronUp size={16} color={theme.palette.grey[400]} />
					) : (
						<ChevronDown size={16} color={theme.palette.grey[400]} />
					))}
			</Stack>
			{showChildren && children}
		</>
	);
};
